module.exports = __webpack_public_path__ + "img/USA-Worst-1980 - 2009.e55c39f6.png";